import {ShellComponent} from "@/components/shell/ShellComponent";

export function Shell({noHeader, children}: { noHeader?: boolean | undefined, children: React.ReactNode }) {
    return <ShellComponent noHeader={noHeader}>{children}</ShellComponent>;
}
